import { useNavigate } from "react-router-dom";
import ContentWrapper from "../ContentWrapper";
import Img from "../LazyLoadImage";
import PosterFallback from "../../assets/images/no-poster.png";
import "./styles.scss";
import moment from "moment";
import Tags from "../Tags";
import { PriceSelection, getCurrency, getTags } from "../../utils/functions";

type Props = {
  data: any;
  loading: boolean;
  title?: string;
};

const Card = ({ data, loading, title }: Props) => {
  const imageURL = process.env.REACT_APP_IMAGEURL;
  const navigate = useNavigate();

  const currency = data && getCurrency(data[0]);

  const SkItem = () => {
    return (
      <div className="skeletonItem">
        <div className="posterBlock skeleton"></div>
        <div className="textBlock">
          <div className="title skeleton"></div>
          <div className="date skeleton"></div>
        </div>
      </div>
    );
  };

  return (
    <div className="cardsGrid pt-44">
      <ContentWrapper>
        {title && <div className="cardsTitle">{title}</div>}
        {!loading ? (
          <div className="gridContainer">
            {data
              ?.slice() // create a copy so we don’t mutate the original
              .sort(
                (a: any, b: any) =>
                  moment(b.from_date).valueOf() - moment(a.from_date).valueOf()
              )
              .map((item: any, i: number) => {
                const posterUrl = item?.imgs[0]?.img
                  ? imageURL + item.imgs[0].img
                  : PosterFallback;

                return (
                  <div
                    key={i}
                    className="gridItem"
                    onClick={() => navigate(`/details/${item.slug}`)}
                  >
                    <div className="posterBlock">
                      <Img src={posterUrl} />
                      <div className="imageOverlay"></div>
                      <div className="tags">
                        <Tags data={getTags(item?.tags).slice(0, 2)} />
                      </div>
                    </div>
                    <div className="textBlock">
                      <span className="title">{item.title}</span>
                      <span className="price">
                        <PriceSelection
                          ticketCategories={item.ticketCategories}
                          currency={currency as string}
                        />
                      </span>
                      <span className="date">
                        {moment(item.from_date).format("MMM D, YYYY")}
                      </span>
                    </div>
                  </div>
                );
              })}
          </div>
        ) : (
          <div className="loadingSkeleton">
            <SkItem />
            <SkItem />
            <SkItem />
            <SkItem />
            <SkItem />
          </div>
        )}
      </ContentWrapper>
    </div>
  );
};

export default Card;
